import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Grid, List, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import TopViewNav from '../CommonComponents/TopViewNav'
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Container } from '@mui/system';
import { SummaryAction } from '../../actions/summary';
import { CompanyAndUsersData } from '../../actions/CompanyAndUsers';
import './CompanyStatus.css'
import { companyWiseEmp } from '../../actions/Companywiseclient';
import DropList from './DragDrop';




function Companywiseclientstatus({ sortedList, setSortedList, fetchcompanyclientstatusDataList, companyId, setCompanyId }) {
    const [companyList, setCompanyList] = useState([])
    const [userList, setUserList] = useState([])
    const [userId, setUserId] = useState({})
    const [AutoSelectUser, setAutoSelectUser] = useState()
    // const [companyId, setCompanyId] = useState()
    const [finalvalue, setFinalvalue] = useState(false)
    const [selected, setSelected] = useState([]);
    const [statausValue, setStatausValue] = useState("")
    const [BackWordStatus, setBackWordStatus] = useState(false)
    const [FinalStatus, setFinalStatus] = useState(false)
    const [editeValue, setEditValue] = useState(null)
    const [showEditValue, setShowEdite] = useState(false)
    const [FixedOrderStataus, setFixedOrderStataus] = useState(false)
    const [CompanyConfigurationData, setCompanyConfigurationData] = useState([])
    // const [sortedList, setSortedList] = useState([])
    // const[addCilentSatatus,setAddCilentSatatus]=useState({ hrmsCompanyId: companyId ? companyId.id : null, id: null, statusName:statausValue, isFinal: finalvalue, srNo: sortedList.length - 1+1 })








    let addCilentSatatus = [{ hrmsCompanyId: companyId ? companyId.id : null, id: null, statusName: "", isFinal: false, srNo: sortedList.length - 1 + 1 }]


    console.log(addCilentSatatus, "dgwegwyef")

    const newLine = () => {
        console.log(sortedList)
        // setSortedList(sortedList.concat(addCilentSatatus))
        setSortedList([...sortedList, { hrmsCompanyId: companyId ? companyId.id : null, id: null, statusName: "", isFinal: false, srNo: sortedList.length - 1 + 1 }])

        // setStatausValue("")
        // setFinalvalue(false)
    }
    const getOnchangevalue = (e, i) => {
        const { name, value } = e.target
        const onchangeVal = [...sortedList]
        onchangeVal[i][name] = value
        setSortedList(onchangeVal)
       // setStatausValue(onchangeVal)

    }

    const getOnchangevalue1 = (e, i) => {
        // setStatausValue(e.target.value)
        const { name, value } = e.target
        const onchangeVal1 = [...sortedList]
        onchangeVal1[i][name] = e.target.checked
        setSortedList(onchangeVal1)



    }
    console.log(sortedList, "sortedList")

    const fetchCompanyList = async () => {
        const res = await CompanyAndUsersData.fetchCompanyAndUserList();
        if (res !== null) {
            setCompanyList(res.data);
        } else {
            setCompanyList([]);
        }
    };



    const fetchOwnerList = async () => {
        let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
        const data={
            hrmsUserId:hrmsID && hrmsID,
            userId :JSON.parse(localStorage.getItem("data")).id
          }
        const res = await SummaryAction.FetchUserList(data);
        if (res !== null) {
            console.log(res);
            setUserList(res.data);

        } else {
            setUserList([]);
        }
    };




    // const fetchClientBaseEmp = () => {
    //     console.log(companyId, "companyId")
    //     if ((companyId === undefined || companyId === null)) {
    //         alert("Please Select Company!")
    //         return false
    //     }

    //     const data = {
    //         companyId: companyId ? companyId.id : null
    //     }
    //     companyWiseEmp.fetchCompnyWiseUpdate(data).then((response) => {
    //         if (response !== null) {
    //             setCompanyConfigurationData(response.data)
    //             const mettingstart = response.data && response.data.filter((val) => val.hrmsConfigurationName === "is One step back allowed")
    //             const Schedule = response.data && response.data.filter((val) => val.hrmsConfigurationName === "is Final state Editable")
    //             const Allclient = response.data && response.data.filter((val) => val.hrmsConfigurationName === "Fixed order of status")


    //             setBackWordStatus(mettingstart && mettingstart.length > 0 ? mettingstart[0].isEnable : false)
    //             setFinalStatus(Schedule && Schedule.length > 0 ? Schedule[0].isEnable : false)
    //             setFixedOrderStataus(Allclient && Allclient.length > 0 ? Allclient[0].isEnable : false)



    //         }
    //         else {
    //             setBackWordStatus(false)
    //             setFinalStatus(false)
    //             setFixedOrderStataus(false)


    //         }
    //     })
    // }

    const fetchCompanyConfiguration = () => {
        if ((companyId === undefined || companyId === null)) {
            alert("Please Select Company!")
            return false
        }

        const mettingstart = CompanyConfigurationData && CompanyConfigurationData.filter((val) => val.hrmsConfigurationName === "is One step back allowed")
        const Schedule = CompanyConfigurationData && CompanyConfigurationData.filter((val) => val.hrmsConfigurationName === "is Final state Editable")
        const Allclient = CompanyConfigurationData && CompanyConfigurationData.filter((val) => val.hrmsConfigurationName === "Fixed order of status")

        const data =
            [
                {
                    ids: mettingstart && mettingstart.length > 0 ? [mettingstart[0].id] : null,
                    hrmsConfigurationName: "is One step back allowed",
                    companyId: companyId ? companyId.id : null,
                    isEnable: BackWordStatus,

                },
                {
                    ids: Schedule && Schedule.length > 0 ? [Schedule[0].id] : null,
                    hrmsConfigurationName: "is Final state Editable",
                    companyId: companyId ? companyId.id : null,
                    isEnable: FinalStatus,
                },
                {
                    ids: Allclient && Allclient.length > 0 ? [Allclient[0].id] : null,
                    hrmsConfigurationName: "Fixed order of status",
                    companyId: companyId ? companyId.id : null,
                    isEnable: FixedOrderStataus,
                },


            ]
        companyWiseEmp.fetchCompnatbyData(data).then((response) => {
            if (response !== null) {
                //fetchClientBaseEmp()
                alert("Updated Successfully!!")

            }
            else {

            }
        })
        setStatausValue("")

    }

    // const fetchcompanyclientstatusDataList = () => {
    //     debugger;

    //     fetchClientBaseEmp()
    //     const data =
    //     {
    //         hrmsCompanyId: companyId ? companyId.id : null,
    //     }
    //     companyWiseEmp.fetchcompanyclientstatusmaster(data).then((response) => {
    //         if (response !== null) {
    //             setSortedList(response.data)
    //             //alert("successFul")
    //             if (response.responseCode === 404) {
    //                 alert("No record found")
    //                 setSortedList([])
    //             }
    //         }
    //         else {
    //             setSortedList([])
    //         }
    //     })

    // }



    const fetchcompanyclientstatusData = () => {
       
        if ((companyId === undefined || companyId === null)) {
            alert("Please Select Company!")
            return false
        }

        let data = [];
        const datalist = sortedList && sortedList.map((val, ind) => {

            if (Object.keys(val).length !== 0) {
                data.push(val)
            }
        });

    
        if (sortedList.length === 0) {
            alert("Please Add Client status !")
            return false

        }
        else if (data.length > 0 && data[data.length - 1].statusName === "") {
            alert("Status should not be empty!")
            return false
        }
        else if ((data.length > 0 && data[data.length - 1].statusName === "NA" || data.length > 0 && data[data.length - 1].statusName === "na")) {
            alert("Status should not be NA!")
            return false
        }
    
        companyWiseEmp.fetchcompanyclientstatus(data).then((response) => {
            if (response !== null) {
                //setEditValue(null)
                fetchcompanyclientstatusDataList()
                alert("Add successfully")

            }
        })
        setStatausValue("")
        setEditValue(null)
        setShowEdite(false)

    }

    // const fetchUpdatecompanyclientstatusDataList = (rowdata) => {
    //     const data =
    //     {
    //         id: rowdata.id,
    //         hrmsCompanyId: rowdata.hrmsCompanyId,
    //         statusName: rowdata.statusName,.
    //         statusPrevName: rowdata.statusPrevName,
    //         statusUpdatedName: rowdata.statusUpdatedName,
    //         isActive: rowdata.isActive,
    //         orderId: rowdata.orderId,
    //         prevOrder: rowdata.prevOrder,
    //         nextOrder: rowdata.nextOrder,
    //         createdAt: rowdata.createdAt,
    //         updatedAt: rowdata.updatedAt,
    //         prevStatusName: rowdata.prevStatusName,
    //         nextStatusName: rowdata.nextStatusName,
    //         srNo: rowdata.srNo,
    //         isFinal: rowdata.isFinal,


    //     }
    //     companyWiseEmp.fetchDeletecompanyclientstatusmaster(data).then((response) => {
    //         if (response !== null) {
    //             alert("Update successfully")
    //         }
    //     })

    // }

    useEffect(() => {
        fetchCompanyList()
        fetchOwnerList()

    }, [])

    const topViewNavData = {
        title: "Company wise Client Status",
        backPathRoute: "/dashboard",
    };
    return (
        <div>
            {/* <main className="contents__root" style={{ marginTop: "10px" }}> */}
            {/* <Grid container spacing={1}> */}
            {/* <Grid item xs={12}>
                        <TopViewNav topViewNavData={topViewNavData} />
                    </Grid> */}

            {/* <Container sx={{ paddingBottom: "20px" }} maxWidth="true">
                        <Grid
                            container
                            spacing={2}
                            style={{ placeItems: "center", justifyContent: "end" }}
                        >

                            <Grid item xs={4}>
                                <Box className="top_fields" display={"flex"} gap="3px">
                                    <div className="field_box">
                                        <Autocomplete
                                            size="small"
                                            id="header"
                                            className="select_box"
                                            options={companyList || []}
                                            getOptionLabel={(option) => `${option.companyName}`}
                                            disablePortal={true}
                                            fullWidth
                                            onChange={(event, newValue) => {
                                                setCompanyId(newValue);
                                            }}
                                            renderOption={(props, option) => {
                                                return (
                                                    <List
                                                        sx={{ opacity: option.id == 0 ? ".5" : "1" }}
                                                        {...props}
                                                        key={option.id}
                                                    >
                                                        {`${option.companyName}`}
                                                    </List>
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    margin="dense"
                                                    placeholder="Select Company"
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="field_box">
                                        <Autocomplete
                                            size="small"
                                            id="header"
                                            className="select_box"
                                            options={userList || []}
                                            getOptionLabel={(option) => `${option.name}(${option.empCode})`}
                                            disablePortal={true}
                                            fullWidth
                                            onChange={(event, newValue) => {
                                                setUserId(newValue);
                                            }}

                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    margin="dense"
                                                    placeholder="User"
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="field_box">
                                        <div
                                            className="field_box_btn1"
                                            onClick={fetchcompanyclientstatusDataList}
                                            style={{
                                                cursor: "pointer",
                                            }}
                                        >
                                            Submit
                                        </div>
                                    </div>
                                </Box>


                            </Grid>
                        </Grid>
                    </Container> */}

            {/* <Grid className='CompanyBox'>
                        <Accordion className="main_accoardian" defaultExpanded={true}>
                            <AccordionSummary
                                className="accordianHeader"
                                expandIcon={
                                    <AddCircleIcon
                                        fontSize="large"
                                        style={{ color: "white" }}
                                    />
                                }
                                aria-controls="panel1a-content"
                                style={{
                                    background: "rgb(10 166 141)",
                                    borderRadius: "10px 10px 0px 0px",
                                    overflow: "hidden",
                                }}
                            >
                                <Grid>
                                    <Grid >
                                        <h3 style={{ color: "#fff", marginLeft: "10px", padding: "10px 2px" }}>Company Base  Configuration:-</h3>
                                    </Grid>
                                </Grid>

                            </AccordionSummary>
                            <AccordionDetails className="accoardian_body">
                                <Grid sx={{ paddingTop: "10px" }} className="CompanyMainBox">
                                    <TableContainer component={Paper} >
                                        <Table size="small" aria-label="a dense table">
                                            <TableHead style={{ color: "#fff", backgroundColor: "#32577e" }}
                                            >
                                                <TableCell className='tabalecellStyle'>
                                                    S.no
                                                </TableCell>
                                                <TableCell className='tabalecellStyle'>
                                                    Configuration Name
                                                </TableCell >
                                                <TableCell className='tabalecellStyle'>
                                                    Configuration Status
                                                </TableCell>

                                            </TableHead>
                                            <TableBody>

                                                <TableRow>
                                                    <TableCell>
                                                        1
                                                    </TableCell>
                                                    <TableCell>
                                                        BackWord Status Follow
                                                    </TableCell>
                                                    <TableCell>
                                                        <Switch checked={BackWordStatus}
                                                            onChange={(e) => setBackWordStatus(e.target.checked)} color="secondary" />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        2
                                                    </TableCell>
                                                    <TableCell>
                                                        Final Status Changeble
                                                    </TableCell>
                                                    <TableCell>
                                                        <Switch checked={FinalStatus}
                                                            onChange={(e) => setFinalStatus(e.target.checked)} color="secondary" />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        3
                                                    </TableCell>
                                                    <TableCell>
                                                        Fixed order of status
                                                    </TableCell>
                                                    <TableCell>
                                                        <Switch checked={FixedOrderStataus}
                                                            onChange={(e) => setFixedOrderStataus(e.target.checked)} color="secondary" />
                                                    </TableCell>
                                                </TableRow>


                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Grid style={{ placeItems: "center", display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
                                        <div className="field_box">
                                            <div
                                                className="field_box_btn1"
                                                onClick={fetchCompanyConfiguration}
                                                style={{
                                                    cursor: "pointer",
                                                    width: "60px"
                                                }}
                                            >
                                                Save
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>



                            </AccordionDetails>

                        </Accordion>
                    </Grid> */}

            <Grid className='CompanyBox'>
                <Accordion className="main_accoardian" defaultExpanded={true}>
                    <AccordionSummary
                        className="accordianHeader"
                        expandIcon={
                            <AddCircleIcon
                                fontSize="large"
                                style={{ color: "white" }}
                            />
                        }
                        aria-controls="panel1a-content"
                        style={{
                            background: "rgb(10 166 141)",
                            borderRadius: "10px 10px 0px 0px",
                            overflow: "hidden",
                        }}
                    >
                        <Grid>

                            <Grid >
                                <h3 style={{ color: "#fff", marginLeft: "10px", padding: "10px 2px" }}>Status List:-</h3>
                            </Grid>
                        </Grid>
                    </AccordionSummary>
                    <AccordionDetails className="accoardian_body">



                    </AccordionDetails>
                    <Grid sx={{ paddingTop: "10px" }} className="CompanyMainBox">
                        <Grid style={{ placeItems: "center", display: "flex", justifyContent: "flex-end", padding: "10px 0" }}>
                            <div className="field_box">
                                <div
                                    className="field_box_btn1"
                                    onClick={newLine}
                                    style={{
                                        cursor: "pointer",
                                        width: "60px"
                                    }}
                                >
                                    Add
                                </div>
                            </div>
                        </Grid>


                        <DropList selected={selected} setSelected={setSelected} finalvalue={finalvalue} setFinalvalue={setFinalvalue} statausValue={statausValue} setStatausValue={setStatausValue} sortedList={sortedList} setSortedList={setSortedList} fetchcompanyclientstatusDataList={fetchcompanyclientstatusDataList} editeValue={editeValue} setEditValue={setEditValue} showEditValue={showEditValue} setShowEdite={setShowEdite} getOnchangevalue={getOnchangevalue} getOnchangevalue1={getOnchangevalue1} />




                        <Grid style={{ placeItems: "center", display: "flex", justifyContent: "flex-end", padding: "10px 0" }}>
                            <div className="field_box">
                                <div
                                    className="field_box_btn1"
                                    onClick={fetchcompanyclientstatusData}
                                    style={{
                                        cursor: "pointer",
                                        width: "60px"
                                    }}
                                >
                                    Save
                                </div>
                            </div>
                        </Grid>

                    </Grid>



                </Accordion>

            </Grid>

            {/* </Grid>
            </main> */}
        </div>
    )
}

export default Companywiseclientstatus
